import { useState } from 'react';

import { NuveiCard } from '../NuveiCard/NuveiCard';
import { EPaymentProvider } from '../../../../../../contracts';
import { useNuveiSubmit } from '../../../../hooks/use-nuvei-submit';
import { usePaymentState } from '../../../../hooks/use-payment-state';
import { SavedCardsContainer } from '../../../SavedCardContainer/SavedCardContainer';

interface NuveiCardContainerProps {
  onReady: () => void;
}

export function NuveiCardContainer({ onReady }: NuveiCardContainerProps) {
  const savedCards = usePaymentState((state) => state.savedCards);
  const hasSavedCards = Boolean(
    savedCards.filter((card) => card.paymentProvider === EPaymentProvider.nuvei).length
  );
  const [savedCardFlow, setSavedCardFlow] = useState({
    show: hasSavedCards,
    defaultSavedCardChecked: false,
  });
  const { handleSavedCardPay } = useNuveiSubmit();

  const showCardFlow = () => {
    setSavedCardFlow({ show: false, defaultSavedCardChecked: true });
  };

  if (savedCardFlow.show) {
    return (
      <SavedCardsContainer
        onReady={onReady}
        paymentProvider={EPaymentProvider.nuvei}
        onPayClicked={handleSavedCardPay}
        showCardFlow={showCardFlow}
      />
    );
  }

  return (
    <NuveiCard
      onReady={onReady}
      savedCardProps={{
        defaultSaveCardChecked: savedCardFlow.defaultSavedCardChecked,
        onBackButtonClicked: () => setSavedCardFlow({ show: true, defaultSavedCardChecked: false }),
        showBackButton: hasSavedCards,
      }}
    />
  );
}
